'use client';

import { c as _c } from "react/compiler-runtime";
export function NegociacaoDetailLoadingState() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-24 w-full animate-pulse border-b border-neutral-100 bg-neutral-50" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="h-10 w-64 animate-pulse rounded bg-neutral-100" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex h-full w-full flex-col items-start gap-6 overflow-auto p-9">{t0}<div className="flex w-full flex-col gap-6 px-6 py-4 lg:px-9">{t1}<div className="grid grid-cols-1 gap-6 md:grid-cols-3"><div className="col-span-2 h-96 animate-pulse rounded-[16px] bg-neutral-50" /><div className="h-96 animate-pulse rounded-[16px] bg-neutral-50" /></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}